<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveProfile)" class="infoBoxForm">
        <section>
          <div class="row5">
            <article class="inner infoInner mb-5">
              <div class="infoTitle mobileCenter" style="margin-bottom: 6rem;">
                <h1>프로필 정보</h1>
              </div>

              <TabInformation
                :tabs="tabs"
                :activeTab="activeTab"
                :handleChangeTab="handleChangeTab"
                :networkingOn.sync="signupInfo.isOn"
              />

              <div v-if="activeTab == 0">
                <div
                  class="flex mobileFlex wd100"
                  style="margin-top: 4rem; gap: 4rem;"
                >
                  <div class="wd50">
                    <div class="profileImgBox wd100">
                      <div class="profileImgInputBox preview-image">
                        <img :src="imageUrl" alt="" class="upload-name" />
                        <label for="input-file"></label>
                        <input
                          type="file"
                          id="input-file"
                          class="upload-hidden"
                          @change="setFileImage"
                        />
                      </div>
                    </div>
                  </div>
                  <!-- Right side  -->
                  <div class="flex flex-col wd50">
                    <div>
                      <div class="inputBox infoBox wd50">
                        <label>아이디<span class="labelItem">*</span></label>
                        <input
                          v-model="signupInfo.id"
                          maxlength="20"
                          disabled
                        />
                      </div>

                      <ValidationProvider
                        class="inputBox infoBox wd50"
                        name="비밀번호"
                        rules="pw"
                        vid="비밀번호"
                        v-slot="{ errors }"
                      >
                        <label
                          >비밀번호 <span class="labelItem">*</span> (특수문자
                          포함, 8자리 이상)</label
                        >
                        <input
                          type="password"
                          v-model="signupInfo.password"
                          maxlength="16"
                          autocomplete="new-password"
                          :disabled="signupInfo.isKakao === 'Y'"
                        />
                        <span class="notValidationTxt">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider
                        class="inputBox infoBox wd50"
                        name="비밀번호 재확인"
                        rules="confirmed:@비밀번호"
                        vid="비밀번호 재설정"
                        v-slot="{ errors }"
                      >
                        <label
                          >비밀번호 확인 <span class="labelItem">*</span> (한번
                          더 입력해주세요.)</label
                        >
                        <input
                          type="password"
                          v-model="confirmedPassword"
                          maxlength="16"
                          :disabled="signupInfo.isKakao === 'Y'"
                        />
                        <span class="notValidationTxt">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider
                        class="inputBox infoBox wd50"
                        name="이름"
                        rules="required|name"
                        v-slot="{ errors }"
                      >
                        <label>이름<span class="labelItem">*</span></label>
                        <input v-model="signupInfo.name" maxlength="16" />
                        <span class="notValidationTxt">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="flex mobileFlex" style="gap: 4rem;">
                  <div class="inputBox infoBox wd50">
                    <ValidationProvider
                      class="inputBox infoBox wd50"
                      name="휴대폰번호"
                      rules="required|mobileTel"
                      v-slot="{ errors, valid }"
                    >
                      <label>휴대폰 번호<span class="labelItem">*</span></label>
                      <input
                        v-model="signupInfo.phone"
                        @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                        maxlength="11"
                      />
                      <input
                        type="button"
                        value="인증번호 받기"
                        :disabled="signupInfo.phone === user.phone"
                        @click="onClickRequestVerifyNumber(valid)"
                      />
                      <span class="notValidationTxt">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="inputBox infoBox">
                    <label>성별<span class="labelItem">*</span></label>
                    <div class="bspRadio">
                      <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="signupInfo.gender"
                          :options="genderOptions"
                          :aria-describedby="ariaDescribedby"
                          name="radios-btn-default"
                          buttons
                          style="gap: 2rem;"
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <div class="flex mobileFlex" style="gap: 4rem;">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    :rules="user.phone != signupInfo.phone ? 'required' : ''"
                    name="인증 번호 6자리 입력"
                    v-slot="{ errors }"
                  >
                    <label>인증 번호 6자리 입력</label>
                    <input
                      v-model="verifyNumber"
                      maxlength="6"
                      @keypress="eventUtil.onKeyPressForOnlyDigit($event)"
                      :placeholder="counterPlaceHolder"
                    />
                    <input type="button" value="03:00" class="time-label" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="생년월일"
                    rules="required|dateNoHyphen"
                    v-slot="{ errors }"
                  >
                    <label>생년월일<span class="labelItem">*</span></label>
                    <input
                      v-model="signupInfo.birthday"
                      maxlength="10"
                      placeholder="YYYYMMDD"
                    />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="flex mobileFlex" style="gap: 4rem;">
                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="이메일"
                    rules="required|email"
                    v-slot="{ errors }"
                  >
                    <label>이메일<span class="labelItem">*</span></label>
                    <input v-model="signupInfo.email" maxlength="40" />
                    <span class="notValidationTxt">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <ValidationProvider
                    class="inputBox infoBox wd50"
                    name="구분"
                    rules="required"
                  >
                    <label>구분<span class="labelItem">*</span></label>
                    <div class="flex">
                      <div class="checkBoxItem">
                        <input
                          v-model="signupInfo.classification"
                          type="radio"
                          id="one"
                          value="1"
                          class="radioCheckbox"
                        />
                        <label for="one"> 학생 </label>
                      </div>
                      <div class="checkBoxItem ml-5">
                        <input
                          v-model="signupInfo.classification"
                          type="radio"
                          id="two"
                          value="2"
                          class="radioCheckbox"
                        />
                        <label for="two"> 연구원 </label>
                      </div>
                      <div class="checkBoxItem ml-5">
                        <input
                          v-model="signupInfo.classification"
                          type="radio"
                          id="three"
                          value="3"
                          class="radioCheckbox"
                        />
                        <label for="three"> 기업인 </label>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>

                <Address
                  :signupInfo="signupInfo"
                  :childDataLoaded="childDataLoaded"
                  :defaultSido="signupInfo.categoryTargetIdx"
                  :defaultSigungu="signupInfo.city"
                  @set-address="setAddress"
                  style="gap: 4rem;"
                />

                <div class="warningInfo">
                  <p>
                    위의 항목 중 수정을 원하는 항목을 클릭하시고 새로 수정할
                    정보를 입력하세요.
                    <br />
                    정보입력 후 아래의 수정버튼을 누르시면 회원정보 수정이
                    진행됩니다.
                  </p>
                </div>
              </div>

              <template v-else>
                <NetworkingInformation
                  :form="signupInfo"
                  @update="onUserNetworkingInformationChange"
                />
              </template>
            </article>
            <div class="btnBox flex">
              <button type="submit" class="btnFont redborderBtn">
                수 정
              </button>
              <button
                type="type"
                class="btnFont orangeBtn fixWdBtn"
                @click="membershipWithDrawal"
              >
                회원탈퇴
              </button>
            </div>
          </div>
        </section>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import * as eventUtil from "@/utils/eventUtil";
import Address from "@/components/join/Address";
import axios from "@/axios/axios";
import * as jwtUtil from "@/utils/jwtUtil";
import TabInformation from "@/components/tabs/TabInformation.vue";
import NetworkingInformation from "./NetworkingInformation.vue";
import { resolveApiUrl } from "@/data/url";

export default {
  name: "UserProfile",
  components: {
    ValidationObserver,
    ValidationProvider,
    Address,
    TabInformation,
    NetworkingInformation,
  },
  computed: {
    ...mapGetters("auth", ["getUser", "isChecked"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      eventUtil: eventUtil,
      tabs: ["기본 정보", "네트워킹 정보"],
      activeTab: 0,
      signupInfo: {},
      checkedId: "", // 중복검사 완료된 아이디
      checkedPhoneNumber: "", // 인증을 요청한 전화번호
      confirmedPassword: "", // 비밀번호 재확인 값
      isVerified: false, // 전화번호 인증 여부
      verifyNumber: "", // 인증번호
      counter: 0, // 인증번호 유효 시간 카운터
      counterPlaceHolder: "", // 인증번호 유효 시간 카운터(출력용)
      addr1: "", // addressFind util 주소검색 결과
      postcode: "", // addressFind util 주소검색 결과(우편번호)
      genderOptions: [
        { text: "남", value: "M" },
        { text: "여", value: "F" },
      ],
      options: [
        { text: "남", value: "man" },
        { text: "여", value: "woman" },
      ],
      childDataLoaded: false,
      imageUrl: require("@/assets/images/user/camera-icon.png"),
      file: null,
      originalPhoneNumber: "",
      vertifyPhoneNumber: false,
    };
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    if (this.isChecked == false) {
      this.$alert("알림", "필수 정보가 없습니다. 프로필을 완성해주세요.");
    }
  },
  methods: {
    handleChangeTab(index) {
      this.activeTab = index;
      this.childDataLoaded = index == 0;
    },

    ...mapMutations("auth", ["setUser"]),
    ...mapActions("sms", ["requestVerifyNumber", "confirmVerifyNumber"]),
    ...mapActions("auth", ["signout"]),
    ...mapActions("user", ["requestUserDetail", "updateUser"]),
    ...mapActions("file", ["uploadAvatar"]),
    onClickRequestVerifyNumber(isValidPhoneNumber) {
      if (!isValidPhoneNumber || this.signupInfo.phone === "") {
        this.$alert("알림", "휴대폰번호를 확인해주세요.");
        return;
      }

      const phoneNumber = this.signupInfo.phone;
      this.isVerified = false;

      this.requestVerifyNumber({
        phoneNumber: phoneNumber,
        contents: "[경희대SSK]휴대폰 번호 변경\r\n전화번호 인증",
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.checkedPhoneNumber = phoneNumber; // 인증번호를 요청한 전화번호 저장
            this.$refs.verifyNumberCounter.startCountdown("restart");
            this.$alert(
              "알림",
              "인증번호를 발송했습니다.(유효시간 3분) <br>" +
                "인증번호가 오지 않으면 입력하신 정보가 정확한지 확인하여 주세요.<br>" +
                "이미 가입된 번호이거나, 가상전화번호는 인증번호를 받을 수 없습니다.",
            );
          } else {
            this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
            this.$refs.verifyNumberCounter.finishCountdown();
            if (
              data.ERROR_CODE == "SUCCESSIVE_REQUEST" ||
              data.ERROR_CODE == "BLOCKED"
            ) {
              this.$alert("알림", "5분 뒤에 다시 시도해주세요.");
            } else {
              this.$alert("알림", "인증번호 요청을 실패했습니다.");
            }
          }
        })
        .catch(() => {
          this.checkedPhoneNumber = ""; // 인증번호를 요청한 전화번호 초기화
          this.$refs.verifyNumberCounter.finishCountdown();
          this.$alert("알림", "인증번호 요청을 실패했습니다.");
        });
    },
    onClickConfirmVerifyNumber(isValidVerifyNumber) {
      if (!isValidVerifyNumber || this.verifyNumber === "") {
        return;
      }

      this.confirmVerifyNumber({
        phoneNumber: this.checkedPhoneNumber,
        verifyNum: this.verifyNumber,
      })
        .then((response) => {
          const data = response.data;

          if (data.RESULT == "true") {
            this.isVerified = true;
            this.$refs.verifyNumberCounter.finishCountdown();
            this.$alert("알림", "인증되었습니다.");
          } else {
            this.isVerified = false;
            this.$alert("알림", "유효하지 않은 인증번호 입니다.");
          }
        })
        .catch(() => {
          this.isVerified = false;
          this.$alert("알림", "요청 실패");
        });
    },
    onProcesssVerifyNumberCounter(timeObj) {
      this.counter = timeObj.m * 60 + timeObj.s;
      this.counterPlaceHolder = `${timeObj.m}:${timeObj.s}`;
    },
    onFinishVerifyNumberCounter() {
      this.counter = 0;
      this.counterPlaceHolder = "";
    },
    setFileImage(event) {
      let file = event.target.files[0];
      let fileName = event.target.files[0].name;

      let fileNameArr = fileName.split(".");
      let ext = fileNameArr[fileNameArr.length - 1];

      let checkExts = [
        "gif",
        "png",
        "jpg",
        "jpeg",
        "GIF",
        "PNG",
        "JPG",
        "JPEG",
      ];

      var check = checkExts.some(function(checkExt) {
        return ext === checkExt;
      });

      if (!check) {
        this.$alert(
          "알림",
          "업로드가 불가한 확장자입니다. (gif, png, jpg, jpeg 파일만 업로드할 수 있습니다.)",
        );
        return;
      }

      if (file.size >= 1024 * 1024 * 10) {
        this.$alert("알림", "파일은 한 번에 10mb이하만 업로드 가능합니다.");
        return;
      }

      this.file = file;
      this.imageUrl = URL.createObjectURL(this.file);
    },

    onUserNetworkingInformationChange(val) {
      this.signupInfo = this.lodash.assign(this.signupInfo, val);
    },
    saveProfile() {
      const user = this.user;
      const userInfo = {
        id: user.id,
        password: this.signupInfo.password || "",
        phone: this.signupInfo.phone,
        email: this.signupInfo.email,
        name: this.signupInfo.name,
        avatar: this.signupInfo.avatar,
        gender: this.signupInfo.gender,
        birthday: this.signupInfo.birthday,
        classification: this.signupInfo.classification,
        categoryTargetIdx: this.signupInfo.categoryTargetIdx,
        city: this.signupInfo.city,
        education: this.signupInfo.education,
        school: this.signupInfo.school,
        careers:
          this.signupInfo.careers?.map((item) => ({
            ...item,
            inOffice: item.inOffice ? 1 : 0,
          })) || [],
        aboutMe: this.signupInfo.aboutMe,
        activities: this.signupInfo.activities,
        industries1: this.signupInfo.industries1,
        isOn: this.signupInfo.isOn,
      };
      if (this.vertifyPhoneNumber) {
        if (
          !(
            this.isVerified && this.signupInfo.phone === this.checkedPhoneNumber
          )
        ) {
          this.$alert("알림", "전화번호를 인증해주세요.");
          return;
        }
      }

      if (
        user.phone != userInfo.phone &&
        (userInfo.phone != this.checkedPhoneNumber || !this.isVerified)
      ) {
        this.$alert("알림", "전화번호를 인증해주세요.");
        return;
      }

      if (!(userInfo.password === this.confirmedPassword)) {
        this.$alert("알림", "비밀번호가 일치하지 않습니다.");
        return;
      }

      var response = this.$createConfirmResponse();
      this.$confirm(
        "알림",
        "회원정보 수정 시 기존의 정보는 삭제되고 새로 입력하신 정보로 변경됩니다. 그래도 입력하신 부분의 정보수정을 진행하시겠습니까?",
        "확인",
        "취소",
        response,
        {
          closed: async () => {
            if (response.result) {
              if (this.file) {
                let url = await this.uploadAvatar(this.file);
                if (url) userInfo.avatar = url;
              }
              this.updateUser(userInfo)
                .then((result) => {
                  if (result.status == 200) {
                    this.$alert("알림", "회원정보가 수정되었습니다.", "확인", {
                      closed: () => {
                        this.getUserInfo();
                        this.activeTab = 0;
                        window.scrollTo(0, 0);
                      },
                    });
                  }
                })
                .catch((error) => {
                  console.error(error);
                  this.$alert(
                    "알림",
                    "회원정보 수정 중 에러가 발생했습니다. 관리자에게 문의해주세요. <br>" +
                      error,
                  );
                });
            }
          },
        },
      );
    },
    changePhoneNumber(isValidPhoneNumber) {
      if (
        isValidPhoneNumber &&
        this.originalPhoneNumber != this.signupInfo.phone
      ) {
        this.vertifyPhoneNumber = true;
      } else {
        this.vertifyPhoneNumber = false;
      }
    },
    membershipWithDrawal() {
      let idx = this.getUser.idx;
      var response = this.$createConfirmResponse();

      this.$confirm(
        "알림",
        "회원탈퇴를 하시면 회원님의 등록된 모든 정보가 삭제되어 영구적으로 복구가 불가능합니다. <br>그래도 탈퇴하시겠습니까?",
        "동의",
        "취소",
        response,
        {
          closed: () => {
            if (response.result) {
              let paramDatas = { IDX: idx };
              axios
                .post("/api/profile/delete", paramDatas)
                .then((result) => {
                  if (result.status == 200) {
                    var refreshToken = localStorage.getItem(
                      jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
                    );
                    var userIdx = this.getUser.idx;

                    this.signout({
                      userIdx: userIdx,
                      refreshToken: refreshToken,
                    }).then(() => {
                      this.$alert("알림", "탈퇴가 완료되었습니다.", "확인", {
                        closed: () => {
                          this.$router.push({ path: "/" });
                        },
                      });
                    });
                  }
                })
                .catch((error) => {
                  this.$alert(
                    "알림",
                    "회원정보 삭제에 실패하였습니다." + error,
                  );
                });
            }
          },
        },
      );
    },
    getUserInfo() {
      this.requestUserDetail()
        .then((response) => {
          if (response.status == 200) {
            let user = response.data;
            this.signupInfo = this.lodash.cloneDeep(user);
            this.idx = user.idx;

            if (user.avatar) {
              this.imageUrl = resolveApiUrl("/api" + user.avatar);
            }
          }
        })
        .catch(() => {
          this.$alert("알림", "2단계 카테고리 데이터를 가져올 수 없습니다.");
        });
    },

    setAddress(_, __, addressId, addressDetailId) {
      this.signupInfo.categoryTargetIdx = parseInt(addressId);
      this.signupInfo.city = addressDetailId;
    },
  },
};
</script>

<style scoped lang="scss">
.infoInner > .infoTitle {
  padding: 0 100px;
  text-align: center;
}

.infoInner > div > h1 {
  color: #9e1915;
}

input:disabled {
  color: #7d7d7d;
}

.profileImgBox {
  // padding: 40px 0;
  text-align: center;
}

.profileImgInputBox {
  position: relative;
  height: 400px !important;
  background-color: #efefef !important;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;
  }
}

.profileImgInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.profileImgInputBox label:active {
  transform: scale(0.97);
}

.profileImgInputBox label {
  position: absolute;
  z-index: 1;
  width: 190px;
  height: 190px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: transparent;
  cursor: pointer;
  left: 50%;
  margin-left: -95px;
  /* font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0; */
}

.profileImgInputBox .upload-name {
  border: 0;
  display: inline-block;
  width: 100%;
  height: 100%;
  padding: 0;
  /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
}

.time-label {
  background-color: transparent !important;
  color: #7d7d7d !important;
  box-shadow: none !important;
  border-bottom: 0px !important;
}

/* preview img */
.filebox .upload-display {
  /* 이미지가 표시될 지역 */
  margin-bottom: 5px;
}

@media (min-width: 768px) {
  .filebox .upload-display {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0;
  }
}

.filebox .upload-thumb-wrap {
  /* 추가될 이미지를 감싸는 요소 */
  display: inline-block;
  width: 54px;
  padding: 2px;
  vertical-align: middle;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}

.filebox .upload-display img {
  /* 추가될 이미지 */
  display: block;
  max-width: 100%;
  width: 100% \9;
  height: auto;
}

@media (max-width: 560px) {
  .infoInner > .infoTitle {
    padding: 0;
  }
}
</style>

<style scoped lang="scss">
.bspRadio ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}

.bspSelectBox ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
  @import "~bootstrap-vue/dist/bootstrap-vue.min";
}
</style>
